function record(value: unknown, label: string): Record<string, unknown> {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    throw new Error(`${label} must be an object`);
  }
  return value as Record<string, unknown>;
}

function validateJson(value: unknown, label: string, depth: number): void {
  if (depth > 20) throw new Error(`${label} is too deeply nested`);
  if (value === null || typeof value === "string" || typeof value === "boolean") return;
  if (typeof value === "number") {
    if (!Number.isFinite(value)) throw new Error(`${label} must be finite`);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item, index) => validateJson(item, `${label}[${index}]`, depth + 1));
    return;
  }
  if (typeof value === "object") {
    Object.entries(value).forEach(([key, item]) => (
      validateJson(item, `${label}.${key}`, depth + 1)
    ));
    return;
  }
  throw new Error(`${label} is not canonical JSON`);
}

export function parseLoomAcceptedDefinition(value: unknown): Record<string, unknown> {
  const result = record(value, "acceptedGeometry.definitionBinding.definition");
  validateJson(result, "acceptedGeometry.definitionBinding.definition", 0);
  return result;
}

export function canonicalLoomDefinitionJson(value: unknown): string {
  if (value === null || typeof value === "boolean" || typeof value === "string") {
    return JSON.stringify(value);
  }
  if (typeof value === "number") {
    if (!Number.isFinite(value)) throw new Error("Loom definition contains a non-finite number");
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) return `[${value.map(canonicalLoomDefinitionJson).join(",")}]`;
  if (typeof value === "object") {
    const item = value as Record<string, unknown>;
    return `{${Object.keys(item).sort().map((key) => (
      `${JSON.stringify(key)}:${canonicalLoomDefinitionJson(item[key])}`
    )).join(",")}}`;
  }
  throw new Error("Loom definition contains a non-JSON value");
}
